
const LocalePathGuard = ({ children }) => children;

export default LocalePathGuard;
